/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  CompanyAccessRequestsViewModel,
  AccessRequestApprovedCompanyViewModel,
  AccessRequestResultDto,
  AccessRequestDto,
} from './models';

/**
 * AdminRequestResultApi - API class
 */
export class AdminRequestResultApi extends LinqService {

  /**
   * Creates a new AdminRequestResultApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: AccessRequestResultDto, options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param accessRequestId 
   */
  getAccessRequest(accessRequestId?: string, options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/GetAccessRequest`;
    let query = this.createQuery<AccessRequestDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'accessRequestId', value: accessRequestId && accessRequestId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  getAccessRequests(options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/GetAccessRequests`;
    let query = this.createQuery<CompanyAccessRequestsViewModel>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param requestEmployeeId 
   */
  getApprovedCompanies(requestEmployeeId?: string, options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/GetApprovedCompanies`;
    let query = this.createQuery<AccessRequestApprovedCompanyViewModel>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'requestEmployeeId', value: requestEmployeeId && requestEmployeeId.toString() });
    query = query.withOptions(options);

    return query;
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/GetAsync`;
    let query = this.createQuery<AccessRequestResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/GetTranslatedAsync`;
    let query = this.createQuery<AccessRequestResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/List`;
    let query = this.createQuery<AccessRequestResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/ListTranslated`;
    let query = this.createQuery<AccessRequestResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param accessRequestResultDto 
   */
  saveAccessRequestResultWithAccessRequest(accessRequestResultDto?: AccessRequestResultDto, options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/SaveAccessRequestResultWithAccessRequest`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = accessRequestResultDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: AccessRequestResultDto, options?: QueryOptions) {
    // create query
    const url = `/AdminRequestResult/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
